// Derive the visible CRM without deleting or changing stored customer records.
export function excluirClientesArchivados(state) {
  const ids = new Set((state.leads || []).filter(l => l.archivado).map(l => l.id));
  if (!ids.size) return state;
  const result = { ...state, leads: (state.leads || []).filter(l => !l.archivado) };
  const visible = row => !ids.has(row.leadId);
  for (const key of ["ventas", "contactosHistorial", "tareasFollowup", "historialEtapas", "historialEdicionesLead", "historialAsignaciones", "oportunidadesExpansion"]) {
    result[key] = (state[key] || []).filter(visible);
  }
  const sales = new Set((state.ventas || []).filter(v => ids.has(v.leadId)).map(v => v.id));
  result.pagosCredito = (state.pagosCredito || []).filter(p => !sales.has(p.ventaId) && !ids.has(p.clienteKey));
  result.snapshotsPipeline = (state.snapshotsPipeline || []).flatMap(snapshot => {
    if (!ids.size) return [snapshot];
    // Legacy snapshots cannot safely exclude a customer without a breakdown.
    if (!snapshot.porCliente) return [];
    const rows = snapshot.porCliente.filter(row => !ids.has(row.leadId));
    const filtered = { ...snapshot, porCliente: rows, porEtapa: {} };
    for (const key of ["pipelineNuevos", "pipelineExpansion", "pipelineTotal", "oportunidadesAbiertas", "sinEstimacion", "seguimientoVencido", "ventasActivasCount"]) filtered[key] = Math.round(rows.reduce((sum, row) => sum + (Number(row[key]) || 0), 0) * 100) / 100;
    for (const row of rows) for (const [stage, values] of Object.entries(row.porEtapa || {})) {
      const current = filtered.porEtapa[stage] || { count: 0, monto: 0 };
      filtered.porEtapa[stage] = { count: current.count + values.count, monto: Math.round((current.monto + values.monto) * 100) / 100 };
    }
    return [filtered];
  });
  return result;
}
